import type { SVGProps } from 'react';
const actionCheckmarkTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M3.05401 10.7543C3.32598 10.4824 3.75487 10.4629 4.04926 10.6961L4.11467 10.7543L9.11322 15.7537L19.3273 5.54062C19.5992 5.26865 20.0281 5.24922 20.3225 5.48234L20.3879 5.54062C20.6599 5.81259 20.6793 6.24148 20.4462 6.53587L20.3879 6.60128L9.9096 17.0796C9.49611 17.4931 8.84081 17.5174 8.39887 17.1526L8.31861 17.0796L3.05401 11.815C2.76112 11.5221 2.76112 11.0472 3.05401 10.7543Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default actionCheckmarkTemplateOutline;
